import classes from "./PaymentMethods.module.scss";
import type { ReactNode } from "react";

export type DirectDebitButtonProps = {
  onClick: () => void;
  label?: ReactNode;
};

export function DirectDebitButton(props: Readonly<DirectDebitButtonProps>) {
  const { onClick, label } = props;

  return (
    <button type="button" onClick={onClick} className={classes.button}>
      <span>{label}</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        className={classes.creditCardIcon}
      >
        <g
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          stroke="#212121"
        >
          <path d="m2.25,15.75h13.5" />
          <path d="m2.75,12.75h12.5" />
          <path d="m9,7.75l6.2905.0009c.5299,0,.9595-.4295.9595-.9594h0c0-.3408-.1808-.656-.475-.8281l-5.9513-3.4814c-.5088-.2977-1.1386-.2977-1.6475,0l-5.9513,3.4814c-.2942.1721-.475.4873-.475.8281h0c0,.5299.4296.9595.9595.9594l6.2905-.0009Z" />
          <path d="m7.25,12.75v-4.5" />
          <path d="m3.75,12.75v-4.5" />
          <path d="m10.75,12.75v-4.5" />
          <path d="m14.25,12.75v-4.5" />
          <path
            d="m9,6.25c.552,0,1-.448,1-1s-.448-1-1-1-1,.448-1,1,.448,1,1,1Z"
            fill="#212121"
            strokeWidth="0"
          />
        </g>
      </svg>
    </button>
  );
}
